export const MUI_PRO_X_KEY =
  '4940f8103613f1cf050f0bf77a2c609cTz0xMDE1MjIsRT0xNzYyNzI4MjUzMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';
